import React from 'react';
import styled from 'styled-components';
import { theme } from './theme';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import iplangold from './assets/graphics/iplangold.png';
import iplanrentier from './assets/graphics/iplanrentier.png';
import iplanmax from './assets/graphics/iplanmax.png';
import { ACCOUNT_TYPES } from './constants';
import {
  BaseContainer,
  BaseInner,
  BaseFormTitle,
  BaseAccountTypes,
  BaseGrid,
  BaseCard,
  BaseButton,
  BaseAccountImage,
} from './components/shared/BaseAccountSelector';

// GoldenAccounts-specific styled components
const CustomLine = styled.hr`
  border: none;
  border-top: 1px solid ${theme.colors.gold};
  margin: 1rem 0;
`;

const ColumnList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  color: ${theme.colors.white};
  flex-grow: 1;
  margin-bottom: 1.5rem;

  li {
    position: relative;
    padding-left: 1.2em;
    margin-bottom: 0.5em;
    font-size: ${theme.fontSizes.base};
  }

  li::before {
    content: '•';
    position: absolute;
    left: 0;
    top: 0;
    color: ${theme.colors.gold};
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;

/**
 * Props pro GoldenAccounts komponentu
 */
interface GoldenAccountsProps {
  /** Callback volaný při výběru účtu */
  onSelectPlan: (accountType: string) => void;
}

/**
 * Komponenta pro výběr zlatého účtu s detailním ceníkem
 */
export default function GoldenAccounts({ onSelectPlan }: GoldenAccountsProps): React.ReactElement {
  const { t } = useTranslation(['accounts', 'common']);

  return (
    <BaseContainer>
      <BaseInner>
        <Header>
          <BaseFormTitle>{t('accounts:openAccount.title')}</BaseFormTitle>
        </Header>

        <BaseAccountTypes>
          <BaseGrid>
            <BaseCard onClick={() => onSelectPlan(ACCOUNT_TYPES.GOLD)}>
              <BaseAccountImage src={iplangold} alt="" />
              <CustomLine />
              <ColumnList>
                {t('accounts:pricing.gold.highlights', { returnObjects: true }).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ColumnList>
              <BaseButton>{t('common:buttons.learnMore')}</BaseButton>
            </BaseCard>

            <BaseCard onClick={() => onSelectPlan(ACCOUNT_TYPES.RENTIER)}>
              <BaseAccountImage src={iplanrentier} alt="" />
              <CustomLine />
              <ColumnList>
                {t('accounts:pricing.rentier.highlights', { returnObjects: true }).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ColumnList>
              <BaseButton>{t('common:buttons.learnMore')}</BaseButton>
            </BaseCard>

            <BaseCard onClick={() => onSelectPlan(ACCOUNT_TYPES.MAX)}>
              <BaseAccountImage src={iplanmax} alt="" />
              <CustomLine />
              <ColumnList>
                {t('accounts:pricing.max.highlights', { returnObjects: true }).map((item: string, index: number) => (
                  <li key={index}>{item}</li>
                ))}
              </ColumnList>
              <BaseButton>{t('common:buttons.learnMore')}</BaseButton>
            </BaseCard>
          </BaseGrid>
        </BaseAccountTypes>
      </BaseInner>
    </BaseContainer>
  );
}
